export default interface Part {
    id: number;
    name: string;
}

export const partDefaultProps: Part = {
    id: 0,   
    name: "",
}